﻿(function(p, $) {

    var $checkbox = $('.js-checkbox-required input[type=checkbox]');
    var $newCardRadio = $('.js-newCardRadio input[type=radio]');
    var currentYear = new Date().getFullYear();
    var currentMonth = new Date().getMonth() + 1;

    p.ValidateCreditCardStartDate = function(sender, args) {

        var $startMonthDropDown = $('.js_startMonthsDropDown');
        var $startYearDropDown = $('.js_startYearsDropDown');
        if ($newCardRadio.is(':checked')) {
            args.IsValid = true;

            if ($startMonthDropDown.val() !== "" && $startYearDropDown.val() !== "") {
                var startMonth = parseInt($startMonthDropDown.val());
                var startYear = parseInt($startYearDropDown.val()) + 2000;

                if (startYear == currentYear && startMonth > currentMonth) {
                    args.IsValid = false;
                }
            } else if ($startMonthDropDown.val() !== "" || $startYearDropDown.val() !== "") {
                args.IsValid = false;
            }
            return;
        }

        args.IsValid = true;
    };

    p.ValidateCreditCardExpiryDate = function(sender, args) {
        var $expiryMonthDropDown = $('.js_expiryMonthsDropDown');
        var $expiryYearDropDown = $('.js_expiryYearDropDown');

        if ($newCardRadio.is(':checked')) {
            args.IsValid = true;
            var expiryMonth = parseInt($expiryMonthDropDown.val());
            var expiryYear = parseInt($expiryYearDropDown.val()) + 2000;

            if (expiryYear == currentYear && expiryMonth < currentMonth) {
                args.IsValid = false;
            }
            return;
        }
        args.IsValid = true;
    }

    p.ValidateCreditCardNumber = function(sender, args) {
        if ($newCardRadio.is(':checked')) {
            var re = /^\d{12,19}$/;
            args.IsValid = re.test(args.Value);
            return;
        }
        args.IsValid = true;
    }

    p.ValidateSecurityNumber = function (sender, args) {
        var re = /^\d{3,4}$/;
        args.IsValid = re.test(args.Value);
    }

    p.ValidateIssueNumber = function (sender, args) {
        if ($newCardRadio.is(':checked')) {
            var re = /^\d{0,2}$/;
            args.IsValid = re.test(args.Value);
            return;
        }
        args.IsValid = true;
    }

    p.CheckboxRequired = function (sender, args) {
        args.IsValid = $checkbox.is(':checked');
    }

    p.DeliveryInstructionsCollectionPhoneNumber = function(sender, args) {
        args.IsValid = args.Value.trim().length > 5;
    }

    p.DeliveryInstructionsCollectionGiftMessage = function(sender, args) {
        args.IsValid = args.Value.trim().length <= 250;
    }

    p.TermsConditionsCheckboxRequired = function(sender, args) {
        var $tcCheckbox = $('.js-tc-checkbox-required input[type=checkbox]');
        args.IsValid = $tcCheckbox.is(':checked');
    }

    p.Over18CheckboxRequired = function (sender, args) {
        var $18Checkbox = $('.js-18-checkbox-required input[type=checkbox]');
        args.IsValid = $18Checkbox.is(':checked');
    }

    p.ConditionReportCheckboxRequired = function (sender, args) {
        var $conditionReportCheckbox = $('.js-condition-report-checkbox-required input[type=checkbox]');
        args.IsValid = $conditionReportCheckbox.is(':checked');
    }

})(Crafted.Plugins, jQuery);
